<template>
    <v-card v-bind="{ color }" @click="toggle">
        <v-row class="ma-0 pa-0">
            <v-col cols="auto" class="pa-8">
                <v-list-item-avatar></v-list-item-avatar>
            </v-col>
            <v-col class="pa-8">
                <v-list-item-content>
                    <v-list-item-title> {{ item.name }} {{ item.usernmae }} </v-list-item-title>
                    <v-list-item-subtitle> {{ item.gender }} | {{ item.age }} | {{ item.email }} | {{ item.phone }} </v-list-item-subtitle>
                </v-list-item-content>
            </v-col>
            <v-col cols="auto" class="pa-8">
                <v-list-item-action>
                    <v-checkbox :value="isSelected" readonly>
                        <template #label>
                            <span class="ml-4"> 선택하기 </span>
                        </template>
                    </v-checkbox>
                </v-list-item-action>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props: {
        item: { type: Object, default: () => ({}) },
        selected: { type: Array, default: () => [] },
    },
    computed: {
        isSelected() {
            return this.selected.includes(this.item);
        },
        color() {
            return this.isSelected ? "primary darken-4" : undefined;
        },
    },
    methods: {
        toggle() {
            this.$emit("toggle", this.item);
        },
    },
};
</script>

<style>
</style>